// extracted by mini-css-extract-plugin
module.exports = {"root":"ws-form_root__2KTeK","wsForm":"ws-form_wsForm__3kcPH","inputGroup":"ws-form_inputGroup__3Wu0d"};